<div *ngIf="{ partner: partner$ | async } as data" class="flex justify-center items-center">
  <div class="frame flex flex-col justify-center items-center">
    <div
      class="logo w-full flex justify-center items-center"
      [style.backgroundColor]="data.partner.loginHeaderBackground"
    >
      <img [src]="data.partner.logoUrl" alt="logo" />
    </div>
    <ng-content></ng-content>
  </div>
</div>
